import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../../../../modules/auth';
import { KTSVG } from '../../../../../../../_metronic/helpers';
import { useToast } from '../../../../../components/Toats';
import { getTemplateProposalAll } from '../../../../../../services/templatesProposal';
import { putProposalOne } from '../../../../../../services/proposalsService';


type Props = {
  itemProposal: any;
  refresh: any
}

export function TemplateProposal({itemProposal, refresh} : Props) {
    const [loading, setLoading] = useState<boolean>(false);
    const [showModalDescriptionOS, setShowModalDescriptionOS] = useState<boolean>(false);
    const [typeTemplate, setTypeTemplate] = useState<string>("html");
    const [myTemplates, setMyTemplates] = useState<any[]>([]);
    const [myTemplate, setMyTemplate] = useState<any>(null);
    const {currentUser} = useAuth();
    const [loadingTemplates, setLoadingTemplates] = useState(false);
    const { toggleToast } = useToast();

    const getTemplate = async () => {
      try {
        setLoadingTemplates(true)
   
        const templates = await getTemplateProposalAll()
        setMyTemplates(templates)
  
      } catch (error) {
        console.log('erro',error)
        toggleToast("Erro ao buscar os templates. ", "error")
      }finally{
        setLoadingTemplates(false)
      }
    }

    const updateProposalSubmit = async () => {
      try {
        setLoading(true)
        const myData = {
          idTemplate: myTemplate && myTemplate.id ? myTemplate.id : ""
        }
        Object.keys(myData).forEach((prop) => {
          if (myData[prop] === null) {
            delete myData[prop];
          }
        });
        await putProposalOne(itemProposal && itemProposal.id ? itemProposal.id : "", myData);
        toggleToast("Sucesso ao atualizar a proposta. ", "success")
  
  
      } catch (error) {
        console.log('erro',error)
        toggleToast("Erro ao atualizar a proposta. ", "error")
      }finally{
        setLoading(false)
        refresh()
      }
    }

    useEffect(() => {
      setMyTemplate(
        itemProposal 
        && itemProposal.templatesProposals 
        && itemProposal.templatesProposals.length > 0 
        ? itemProposal.templatesProposals[0]
        : null
      )
      getTemplate();
    }, [itemProposal])

    useEffect(() => {
      console.log('template selecionado: ', myTemplate)
    }, [myTemplate])



  return (
    <div className='card'>
        <div
          className='card-header border-0 cursor-pointer'
          role='button'
          data-bs-toggle='collapse'
          data-bs-target='#kt_account_profile_template'
          aria-expanded='true'
          aria-controls='kt_account_profile_template'
        >
          <div className='card-title m-0' style={{justifyContent: 'space-between', width: '100%'}}>
            <h3 className='fw-bolder m-0'>Template {
                itemProposal 
                && itemProposal.templatesProposals 
                ? `(${itemProposal.templatesProposals.length})`
                : ""
              }
            </h3>
            
          <h3 className='fw-bolder text-muted m-0'>{myTemplate ? myTemplate.description : ""} {myTemplate ? `(${myTemplate.typeDoc})` : ""}</h3>
            {/* 
            {currentUser && currentUser.role && currentUser.role.slug && currentUser.role.slug !== 'CLIENTE' && 
              <button
                  className='btn btn-lg text-hover-primary'
                  style={{padding: '0rem'}}
                  onClick={(event) => {
                      event.stopPropagation();
                      setShowModalDescriptionOS(true)
                  }}
                  type="button"
              >
                <KTSVG className='svg-icon-muted svg-icon-2hx' path='/media/icons/duotune/general/gen035.svg' />
              </button>
            } */}

          </div>
        </div>

        <div id='kt_account_profile_template' className='collapse show'>
          <div>
            <div className='card-body border-top p-9'>
                <div className='mb-6' style={{display: 'flex', gap: '1rem', alignItems: 'center'}}>
                    {/* <label className='col-form-label fw-bold fs-6'>Descrição </label> */}

                    <label className='d-flex align-items-center gap-2 fs-5 fw-semibold'>
                        <span>HTML</span>
                        <label className='form-check form-check-inline form-check-primary form-check-solid'>
                            <input
                            className='form-check-input'
                            name='communication[]'
                            type='checkbox'
                            //defaultChecked={true}
                            checked={typeTemplate === "html" ? true : false}
                            onChange={(e) =>{
                                if(e.target.checked){
                                  setTypeTemplate("html")
                                }
                                //setDatesAparent(e.target.checked);
                            }}
                            />
                        </label>
                    </label>

                    <label className='d-flex align-items-center gap-2 fs-5 fw-semibold'>
                        <span>Documento</span>
                        <label className='form-check form-check-inline form-check-primary form-check-solid'>
                            <input
                                className='form-check-input'
                                name='communication[]'
                                type='checkbox'
                                //defaultChecked={true}
                                checked={typeTemplate === "docx" ? true : false}
                                onChange={(e) =>{
                                  if(e.target.checked){
                                    setTypeTemplate("docx")
                                  }
                                  //setDatesAparent(e.target.checked);
                                }}
                            />
                        </label>
                    </label>
                </div>
                {typeTemplate === "docx" ? 
                      <div className="dropdown">
                        <button type="button" className="btn btn-lg btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                          <span>{myTemplate && myTemplate.typeDoc === 'docx' && myTemplate.description ? myTemplate.description : "Selecione um template (docx)"}</span>
                        </button>
                        <div className="dropdown-menu dropdown-menu-end p-4" style={{width: '30rem',}}>
                          <div>
                              <div
                                  style={{maxHeight: '20rem', overflowY: 'auto', overflowX: "clip"}}
                                  //style={{maxHeight: '20rem', overflowY: 'auto'}}
                              >
                              <button
                                  className={`btn btn-sm btn-color-muted px-5 me-1 nav-item bg-hover-light`}
                                  style={{display: 'flex', gap: '1rem', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}
                                  data-bs-toggle="tab"
                                  onClick={()=> {
                                    // selectTemplate("")
                                    // formik.setValues({...formik.values, idTemplate: null})
                                  }}
                              >
                                  <span style={{textAlign: 'start'}}>
                                      Selecione o template
                                  </span>
                              </button>

                              {myTemplates.length > 0 && myTemplates.map((template: any) => {
                                  //const exist_template = formik.values.idsTemplates.find((id) => id === template.id)
                                  if(template.typeDoc === "docx"){
                                    //const exist_template = myTemplate && myTemplate.id && myTemplate.id === template.id ? true : false
                                    //const exist_template = true
                                    return (
                                        <button
                                            className={`btn btn-sm btn-color-muted bg-hover-light ${myTemplate && myTemplate.id && myTemplate.id === template.id ? "border border-solid border-secondary" : ""}  ${myTemplate && myTemplate.id && myTemplate.id === template.id ? "btn-active-primary active" : ""} px-5 me-1 nav-item`}
                                            style={{display: 'flex', gap: '1rem', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}
                                            data-bs-toggle="tab"
                                            onClick={()=> {
                                              setMyTemplate(template)
                                              //selectTemplate(template.id)
                                              //formik.setValues({...formik.values, idTemplate: template.id})
                                            }}
                                        >
                                              <span style={{textAlign: 'start'}}>
                                                  {template.description ? template.description : "Não identificado"} 
                                              </span>
      
                                              <span style={{display: 'flex', gap: '1rem'}}>
                                                <span 
                                                  className={
                                                    `badge badge-light-${
                                                        template.type !== null
                                                        ? template.type === "private"
                                                        ? "primary"
                                                        : template.type === "public"
                                                        ? "success"
                                                        : "secondary"
                                                        : "secondary"
                                                    } fs-7 fw-semibold`
                                                  }
                                                >
                                                    {template.type ? template.type : "Não identificado"} 
                                                </span>

                                                {/* <button
                                                  disabled={template.type && template.type === "public" ? true : false}
                                                  onClick={(event: any) => {
                                                    //handleClickDelete(event, template);
                                                  }}
                                                  //href='#'
                                                  className='btn btn-icon btn-bg-light btn-sm bg-hover-primary text-hover-light'
                                                  style={{height: '2rem'}}
                                                >
                                                    <KTSVG
                                                      path='/media/icons/duotune/general/gen027.svg'
                                                      className='svg-icon-3 text-primary'
                                                    />
                                                </button> */}
                                              </span>
                                        </button>
                                    )
                                  }
                              })}
                              </div>
                          </div>
                        </div>
                      </div>
                    :
                      <div className="dropdown">
                        <button type="button" className="btn btn-lg btn-light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                            <span>{myTemplate && myTemplate.typeDoc === 'html' && myTemplate.description ? myTemplate.description : "Selecione um template"} </span>
                        </button>
                        <div className="dropdown-menu dropdown-menu-end p-4" style={{width: '30rem',}}>
                          <div>
                              <div
                                  style={{maxHeight: '20rem', overflowY: 'auto', overflowX: "clip"}}
                                  //style={{maxHeight: '20rem', overflowY: 'auto'}}
                              >
                              <button
                                className={`btn btn-sm btn-color-muted px-5 me-1 nav-item bg-hover-light`}
                                style={{display: 'flex', gap: '1rem', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}
                                data-bs-toggle="tab"
                                onClick={()=> {
                                    // selectTemplate("")
                                    // formik.setValues({...formik.values, idTemplate: null})
                                }}
                              >
                                  <span style={{textAlign: 'start'}}>
                                      Selecione o template
                                  </span>
                              </button>

                              {myTemplates && myTemplates.map((template: any) => {
                                  //const exist_template = formik.values.idsTemplates.find((id) => id === template.id)
                                  if(template.typeDoc === "html"){
                                    //const exist_template = myTemplate && myTemplate.id && myTemplate.id === template.id ? true : false
                                    return (
                                        <button
                                            className={`btn btn-sm btn-color-muted bg-hover-light ${myTemplate && myTemplate.id && myTemplate.id === template.id ? "border border-solid border-secondary" : ""}  ${myTemplate && myTemplate.id && myTemplate.id === template.id ? "btn-active-primary active" : ""} px-5 me-1 nav-item`}
                                            style={{display: 'flex', gap: '1rem', alignItems: 'center', justifyContent: 'space-between', width: '100%'}}
                                            data-bs-toggle="tab"
                                            onClick={()=> {
                                            
                                            setMyTemplate(template)
                                            // formik.setValues({...formik.values, idTemplate: template.id})
                                            }}
                                        >
                                              <span style={{textAlign: 'start'}}>
                                                  {template.description ? template.description : "Não identificado"} 
                                              </span>
      
                                              <span style={{display: 'flex', gap: '1rem'}}>
                                                <span 
                                                  className={
                                                    `badge badge-light-${
                                                        template.type !== null
                                                        ? template.type === "private"
                                                        ? "primary"
                                                        : template.type === "public"
                                                        ? "success"
                                                        : "secondary"
                                                        : "secondary"
                                                    } fs-7 fw-semibold`
                                                  }
                                                >
                                                    {template.type ? template.type : "Não identificado"} 
                                                </span>

                                                {/* <button
                                                  disabled={template.type && template.type === "public" ? true : false}
                                                  onClick={(event: any) => {
                                                    //handleClickDelete(event, template);
                                                  }}
                                                  //href='#'
                                                  className='btn btn-icon btn-bg-light btn-sm bg-hover-primary text-hover-light'
                                                  style={{height: '2rem'}}
                                                >
                                                    <KTSVG
                                                      path='/media/icons/duotune/general/gen027.svg'
                                                      className='svg-icon-3 text-primary'
                                                    />
                                                </button> */}
                                              </span>
                                        </button>
                                    )
                                  }
                                  
                              })}
                              </div>
                          </div>
                        </div>
                      </div>
                }
            </div>


            <div className='card-footer d-flex justify-content-end py-6 px-9'>
              <button 
                className='btn btn-primary'
                onClick={updateProposalSubmit}
              >
                {!loading && 'Vincular Template'}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Salvando...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
  );
}